import { routes } from 'config/routeSettings';

/**
 * The artifact routes for searching and exploring data.
 *
 * @type {Object}
 *
 * @author Brandon Cummings <brandon.cummings@leargassecurity.com>
 * @version 0.1.0-beta.5
 * @since 0.1.0-beta.1
 */
export const artifactRoutes = {
  active: true,
  allowedRoles: ['super-admin', 'admin', 'user'],
  description:
    'Monitor your artifacts from various sources, including cloud integrations, network traffic, and endpoints.',
  development: false,
  icon: 'shapes',
  iconGrow: 2,
  iconCollection: 'fas',
  imageDark: '',
  imageLight: '',
  label: 'Artifacts',
  labelDisable: false,
  itemDisable: false,
  name: 'Artifacts',
  pageTitle: 'Artifacts',
  to: routes.ARTIFACTS,
  children: [
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Explore all your artifacts, including ones produced by our network appliances and cloud integrations.',
      development: false,
      icon: 'binoculars',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Explore',
      labelDisable: true,
      itemDisable: false,
      name: 'Explore',
      pageTitle: 'Explore',
      to: routes.ARTIFACTS_EXPLORE
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Explore your cloud artifacts, including AWS, Azure, Box, Duo, Google, Meraki, Office 365, Okta, and more.',
      development: false,
      icon: 'cloud',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Cloud',
      labelDisable: true,
      name: 'Cloud',
      pageTitle: 'Cloud',
      to: routes.ARTIFACTS_CLOUD,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          // badge: {
          //   type: 'pastel-coral-light',
          //   text: 'New'
          // },
          description:
            'View and manage your AWS artifacts, including CloudTrail, CloudWatch, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/awsDark.png',
          imageLight: '/assets/img/illustrations/awsLight.png',
          label: 'AWS',
          labelDisable: true,
          itemDisable: false,
          name: 'AWS',
          pageTitle: 'AWS',
          to: routes.ARTIFACTS_CLOUD_AWS,
          children: [
            {
              active: true,
              allowedRoles: ['super-admin', 'admin', 'user'],
              description: 'View and manage your AWS CloudTrail artifacts',
              development: false,
              icon: '',
              iconCollection: '',
              imageDark: '/assets/img/illustrations/cloudtrail.png',
              imageLight: '/assets/img/illustrations/cloudtrail.png',
              label: 'CloudTrail',
              labelDisable: true,
              itemDisable: false,
              name: 'CloudTrail',
              pageTitle: 'CloudTrail',
              to: routes.ARTIFACTS_CLOUD_AWS_CLOUDTRAIL
            }
          ]
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          // badge: {
          //   type: 'pastel-coral-light',
          //   text: 'New'
          // },
          description:
            'View and manage your Azure artifacts, including Activity Log, Monitor, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/azure.png',
          imageLight: '/assets/img/illustrations/azure.png',
          label: 'Azure',
          labelDisable: true,
          itemDisable: false,
          name: 'Azure',
          pageTitle: 'Azure',
          to: routes.ARTIFACTS_CLOUD_AZURE
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Box artifacts, including files, folders, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/box.png',
          imageLight: '/assets/img/illustrations/box.png',
          label: 'Box',
          labelDisable: true,
          itemDisable: false,
          name: 'Box',
          pageTitle: 'Box',
          to: routes.ARTIFACTS_CLOUD_BOX
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Duo artifacts, including authentication logs, devices, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/duo.png',
          imageLight: '/assets/img/illustrations/duo.png',
          label: 'Duo',
          labelDisable: true,
          itemDisable: false,
          name: 'Duo',
          pageTitle: 'Duo',
          to: routes.ARTIFACTS_CLOUD_DUO
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Google artifacts, including Gmail, Drive, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/google.png',
          imageLight: '/assets/img/illustrations/google.png',
          label: 'Google',
          labelDisable: true,
          itemDisable: false,
          name: 'Google',
          pageTitle: 'Google',
          to: routes.ARTIFACTS_CLOUD_GOOGLE
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Meraki artifacts, including devices, networks, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/meraki.png',
          imageLight: '/assets/img/illustrations/meraki.png',
          label: 'Meraki',
          labelDisable: true,
          itemDisable: false,
          name: 'Meraki',
          pageTitle: 'Meraki',
          to: routes.ARTIFACTS_CLOUD_MERAKI
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Office 365 artifacts, including email, SharePoint, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/o365.png',
          imageLight: '/assets/img/illustrations/o365.png',
          label: 'Office 365',
          labelDisable: true,
          itemDisable: false,
          name: 'Office 365',
          pageTitle: 'Office 365',
          to: routes.ARTIFACTS_CLOUD_O365
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Okta artifacts, including users, groups, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/okta.png',
          imageLight: '/assets/img/illustrations/okta.png',
          label: 'Okta',
          labelDisable: true,
          itemDisable: false,
          name: 'Okta',
          pageTitle: 'Okta',
          to: routes.ARTIFACTS_CLOUD_OKTA
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your SonicWall CSE artifacts, including sessions, blocked events, device posture, and user activity.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/sonicwallcseDark.png',
          imageLight: '/assets/img/illustrations/sonicwallcseLight.png',
          label: 'SonicWall CSE',
          labelDisable: true,
          itemDisable: false,
          name: 'SonicWall CSE',
          pageTitle: 'SonicWall CSE',
          to: routes.ARTIFACTS_CLOUD_SONICWALL_CSE
        }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Explore your Darkweb artifacts, including keywords, forum hits, shodan hits, Tor hits, credit card numbers, and more.',
      development: false,
      icon: 'comments-dollar',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Darkweb',
      labelDisable: true,
      name: 'Darkweb',
      pageTitle: 'Darkweb',
      to: routes.ARTIFACTS_DARKWEB
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Explore all your endpoint artifacts, including SentinelOne agents and threats, Windows event logs, Syslog, and more.',
      development: false,
      icon: 'computer',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Endpoint',
      labelDisable: true,
      name: 'Endpoint',
      pageTitle: 'Endpoint',
      to: routes.ARTIFACTS_ENDPOINT,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Crowdstrike artifacts, including detections, incidents, and more.',
          development: true,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Crowdstrike',
          labelDisable: true,
          itemDisable: false,
          name: 'Crowdstrike',
          pageTitle: 'Crowdstrike',
          to: routes.ARTIFACTS_ENDPOINT_CROWDSTRIKE
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and your SentinelOne artifacts, including threats, agents, activities, and custom STAR rules.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/sentinelOneNew.png',
          imageLight: '/assets/img/illustrations/sentinelOneNew.png',
          label: 'SentinelOne',
          labelDisable: true,
          itemDisable: false,
          name: 'SentinelOne',
          pageTitle: 'SentinelOne',
          to: routes.ARTIFACTS_ENDPOINT_SENTINELONE,
          children: [
            {
              active: true,
              allowedRoles: ['super-admin', 'admin', 'user'],
              description: 'View all SentinelOne activity artifacts.',
              development: false,
              icon: '',
              iconCollection: '',
              imageDark: '/assets/img/illustrations/sentinelOneAgent.png',
              imageLight: '/assets/img/illustrations/sentinelOneAgent.png',
              label: 'Activities',
              labelDisable: true,
              itemDisable: false,
              name: 'Activities',
              pageTitle: 'Activities',
              to: routes.ARTIFACTS_ENDPOINT_SENTINELONE_ACTIVITIES
            },
            {
              active: true,
              allowedRoles: ['super-admin', 'admin', 'user'],
              description: 'View all SentinelOne agent artifacts.',
              development: false,
              icon: '',
              iconCollection: '',
              imageDark: '/assets/img/illustrations/sentinelOneAgent.png',
              imageLight: '/assets/img/illustrations/sentinelOneAgent.png',
              label: 'Agents',
              labelDisable: true,
              itemDisable: false,
              name: 'Agents',
              pageTitle: 'Agents',
              to: routes.ARTIFACTS_ENDPOINT_SENTINELONE_AGENTS
            },
            {
              active: true,
              allowedRoles: ['super-admin', 'admin', 'user'],
              description: 'View all SentinelOne STAR rule artifacts.',
              development: false,
              icon: '',
              iconCollection: '',
              imageDark: '/assets/img/illustrations/sentinelOneAgent.png',
              imageLight: '/assets/img/illustrations/sentinelOneAgent.png',
              label: 'STAR Rules',
              labelDisable: true,
              itemDisable: false,
              name: 'STAR Rules',
              pageTitle: 'STAR Rules',
              to: routes.ARTIFACTS_ENDPOINT_SENTINELONE_STAR_RULES
            },
            {
              active: true,
              allowedRoles: ['super-admin', 'admin', 'user'],
              description: 'View all SentinelOne threat artifacts.',
              development: false,
              icon: '',
              iconCollection: '',
              imageDark: '/assets/img/illustrations/sentinelOneAlert.png',
              imageLight: '/assets/img/illustrations/sentinelOneAlert.png',
              label: 'Threats',
              labelDisable: true,
              itemDisable: false,
              name: 'Threats',
              pageTitle: 'Threats',
              to: routes.ARTIFACTS_ENDPOINT_SENTINELONE_THREATS
            }
          ]
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Windows artifacts, including logs, events, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/windows.png',
          imageLight: '/assets/img/illustrations/windows.png',
          label: 'Windows',
          labelDisable: true,
          itemDisable: false,
          name: 'Windows',
          pageTitle: 'Windows',
          to: routes.ARTIFACTS_ENDPOINT_WINDOWS
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Microsoft Defender 365 alerts and security events.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/defender365.png',
          imageLight: '/assets/img/illustrations/defender365.png',
          label: 'Defender 365',
          labelDisable: true,
          itemDisable: false,
          name: 'Defender 365',
          pageTitle: 'Defender 365',
          to: routes.ARTIFACTS_ENDPOINT_DEFENDER_365
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Microsoft Defender XDR telemetry and process events.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/defenderxdr.png',
          imageLight: '/assets/img/illustrations/defenderxdr.png',
          label: 'Defender XDR',
          labelDisable: true,
          itemDisable: false,
          name: 'Defender XDR',
          pageTitle: 'Defender XDR',
          to: routes.ARTIFACTS_ENDPOINT_DEFENDER_XDR
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Syslog artifacts, including logs, events, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/syslog.png',
          imageLight: '/assets/img/illustrations/syslog.png',
          label: 'Syslog',
          labelDisable: true,
          itemDisable: false,
          name: 'Syslog',
          pageTitle: 'Syslog',
          to: routes.ARTIFACTS_ENDPOINT_SYSLOG
        }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'View and manage your ICS/OT artifacts, and drill down into events by protocol.',
      development: false,
      icon: 'building',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'ICS/OT',
      labelDisable: true,
      itemDisable: false,
      name: 'ICS/OT',
      pageTitle: 'ICS/OT',
      to: routes.ARTIFACTS_ICS,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network behaviors, including DNS, HTTP, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'BACnet',
          labelDisable: true,
          itemDisable: false,
          name: 'BACnet',
          pageTitle: 'ICS - BACnet',
          to: routes.ARTIFACTS_ICS_BACNET
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network signatures, including Snort, Suricata, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'ENIP/CIP',
          labelDisable: true,
          itemDisable: false,
          name: 'ENIP/CIP',
          pageTitle: 'ICS - ENIP/CIP',
          to: routes.ARTIFACTS_ICS_ENIP_CIP
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network threat intelligence artifacts',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'DNP3',
          labelDisable: true,
          itemDisable: false,
          name: 'DNP3',
          pageTitle: 'ICS - DNP3',
          to: routes.ARTIFACTS_ICS_DNP3
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network SMB artifacts, including files, shares, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Ethernet/IP',
          labelDisable: true,
          itemDisable: false,
          name: 'Ethernet/IP',
          pageTitle: 'ICS - Ethernet/IP',
          to: routes.ARTIFACTS_ICS_ETHERNET_IP
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network RPC artifacts, including services, ports, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'HART',
          labelDisable: true,
          itemDisable: false,
          name: 'HART',
          pageTitle: 'ICS - HART',
          to: routes.ARTIFACTS_ICS_HART
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network ICS artifacts, including devices, protocols, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Modbus',
          labelDisable: true,
          itemDisable: false,
          name: 'Modbus',
          pageTitle: 'ICS - Modbus',
          to: routes.ARTIFACTS_ICS_MODBUS
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description: 'View and manage your network file extraction artifacts',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'OPC UA',
          labelDisable: true,
          itemDisable: false,
          name: 'OPC UA',
          pageTitle: 'ICS - OPC UA',
          to: routes.ARTIFACTS_ICS_OPC_UA
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description: 'View and manage your network file extraction artifacts',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'PROFINET',
          labelDisable: true,
          itemDisable: false,
          name: 'PROFINET',
          pageTitle: 'ICS - PROFINET',
          to: routes.ARTIFACTS_ICS_PROFINET
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description: 'View and manage your network file extraction artifacts',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'S7',
          labelDisable: true,
          itemDisable: false,
          name: 'S7',
          pageTitle: 'ICS - S7',
          to: routes.ARTIFACTS_ICS_S7
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description: 'View and manage your network file extraction artifacts',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Synchrophasor',
          labelDisable: true,
          itemDisable: false,
          name: 'Synchrophasor',
          pageTitle: 'ICS - Synchrophasor',
          to: routes.ARTIFACTS_ICS_SYNCHROPHASOR
        }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Explore all your network artifacts, including behaviors, signatures, threat intel hits, SMB, RPC, ICS, and file extraction',
      development: false,
      icon: 'sitemap',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Network',
      labelDisable: true,
      name: 'Network',
      pageTitle: 'Network',
      to: routes.ARTIFACTS_NETWORK,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network behaviors, including DNS, HTTP, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Behaviors',
          labelDisable: true,
          itemDisable: false,
          name: 'Behaviors',
          pageTitle: 'Behaviors',
          to: routes.ARTIFACTS_NETWORK_BEHAVIORS
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network signatures, including Snort, Suricata, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Signatures',
          labelDisable: true,
          itemDisable: false,
          name: 'Signatures',
          pageTitle: 'Signatures',
          to: routes.ARTIFACTS_NETWORK_SIGNATURES
        },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description: 'View and manage your network file extraction artifacts',
        //   development: true,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'File Extraction',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'File Extraction',
        //   pageTitle: 'File Extraction',
        //   to: routes.ARTIFACTS_NETWORK_FILEEXTRACTION
        // },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network threat intelligence artifacts',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Threat Intel',
          labelDisable: true,
          itemDisable: false,
          name: 'Threat Intel',
          pageTitle: 'Threat Intel',
          to: routes.ARTIFACTS_NETWORK_THREATINTEL
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network RPC artifacts, including services, ports, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'RPC',
          labelDisable: true,
          itemDisable: false,
          name: 'RPC',
          pageTitle: 'RPC',
          to: routes.ARTIFACTS_NETWORK_DCE_RPC
        },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network SMB artifacts, including files, shares, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'DNS',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'DNS',
        //   pageTitle: 'DNS',
        //   to: routes.ARTIFACTS_NETWORK_DNS
        // },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network RPC artifacts, including services, ports, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Files',
          labelDisable: true,
          itemDisable: false,
          name: 'Files',
          pageTitle: 'Files',
          to: routes.ARTIFACTS_NETWORK_FILES
        },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network RPC artifacts, including services, ports, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'FTP',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'FTP',
        //   pageTitle: 'FTP',
        //   to: routes.ARTIFACTS_NETWORK_FTP
        // },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network RPC artifacts, including services, ports, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'HTTP',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'HTTP',
        //   pageTitle: 'HTTP',
        //   to: routes.ARTIFACTS_NETWORK_HTTP
        // },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network RPC artifacts, including services, ports, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'Kerberos',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'Kerberos',
        //   pageTitle: 'Kerberos',
        //   to: routes.ARTIFACTS_NETWORK_KERBEROS
        // },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network RPC artifacts, including services, ports, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'MySQL',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'MySQL',
        //   pageTitle: 'MySQL',
        //   to: routes.ARTIFACTS_NETWORK_MYSQL
        // },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your network RPC artifacts, including services, ports, and more.',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'SMB',
          labelDisable: true,
          itemDisable: false,
          name: 'SMB',
          pageTitle: 'SMB',
          to: routes.ARTIFACTS_NETWORK_SMB
        }
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network RPC artifacts, including services, ports, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'SMTP',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'SMTP',
        //   pageTitle: 'SMTP',
        //   to: routes.ARTIFACTS_NETWORK_SMTP
        // },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network RPC artifacts, including services, ports, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'SSH',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'SSH',
        //   pageTitle: 'SSH',
        //   to: routes.ARTIFACTS_NETWORK_SSH
        // },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View your network SSL artifacts, including certificates, issuers, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'SSL',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'SSL',
        //   pageTitle: 'SSL',
        //   to: routes.ARTIFACTS_NETWORK_SSL
        // },
        // {
        //   active: true,
        //   allowedRoles: ['super-admin', 'admin', 'user'],
        //   description:
        //     'View and manage your network RPC artifacts, including services, ports, and more.',
        //   development: false,
        //   icon: '',
        //   iconCollection: '',
        //   imageDark: '',
        //   imageLight: '',
        //   label: 'Tunnel',
        //   labelDisable: true,
        //   itemDisable: false,
        //   name: 'Tunnel',
        //   pageTitle: 'Tunnel',
        //   to: routes.ARTIFACTS_NETWORK_TUNNEL
        // }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'View and manage your physical artifacts, including cameras, doors, and more.',
      development: true,
      icon: 'building',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Physical',
      labelDisable: true,
      name: 'Physical',
      pageTitle: 'Physical',
      to: routes.ARTIFACTS_PHYSICAL
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'View and manage your vulnerability artifacts, including Nessus, OpenVAS, Qualys, and more.',
      development: true,
      icon: 'bug',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Vulnerabilities',
      labelDisable: true,
      name: 'Vulnerabilities',
      pageTitle: 'Vulnerabilities',
      to: routes.ARTIFACTS_VULNS,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Nessus vulnerability artifacts, including scans, reports, and more.',
          development: true,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Nessus',
          labelDisable: true,
          itemDisable: false,
          name: 'Nessus',
          pageTitle: 'Nessus',
          to: routes.ARTIFACTS_VULNS_NESSUS
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your OpenVAS vulnerability artifacts, including scans, reports, and more.',
          development: true,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'OpenVAS',
          labelDisable: true,
          itemDisable: false,
          name: 'OpenVAS',
          pageTitle: 'OpenVAS',
          to: routes.ARTIFACTS_VULNS_OPENVAS
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description:
            'View and manage your Qualys vulnerability artifacts, including scans, reports, and more.',
          development: true,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Qualys',
          labelDisable: true,
          itemDisable: false,
          name: 'Qualys',
          pageTitle: 'Qualys',
          to: routes.ARTIFACTS_VULNS_QUALYS
        }
      ]
    }
  ]
};

/**
 * The resources routes for reading news and updates.
 *
 * @type {Object}
 *
 * @author Brandon Cummings <brandon.cummings@leargassecurity.com>
 * @version 0.1.0-beta.5
 * @since 0.1.0-beta.1
 */
export const resourceRoutes = {
  active: true,
  allowedRoles: ['super-admin', 'admin', 'user'],
  description:
    'Read the latest news and updates that are relevant to you and your organization',
  development: false,
  icon: 'book-open',
  iconShrink: 2,
  iconCollection: 'fas',
  imageDark: '',
  imageLight: '',
  label: 'Resources',
  labelDisable: false,
  itemDisable: false,
  name: 'Resources',
  pageTitle: 'Resources',
  to: routes.RESOURCES,
  children: [
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'View the API documentation and explore the API endpoints and methods',
      development: true,
      icon: 'globe',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'API Docs',
      labelDisable: true,
      itemDisable: false,
      name: 'API Docs',
      pageTitle: 'API Docs',
      to: routes.RESOURCES_API_DOCS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Review the latest changes and updates to the Léargas application and its features',
      development: false,
      icon: 'file-invoice',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Change Log',
      labelDisable: true,
      itemDisable: false,
      name: 'Change Log',
      pageTitle: 'Change Log',
      to: routes.RESOURCES_CHANGE_LOG
    },
    // {
    //   active: true,
    //   allowedRoles: ['super-admin', 'admin'],
    //   description:
    //     'View the Dev documentation and explore the frontend components and utilities',
    //   development: true,
    //   icon: 'code',
    //   iconCollection: 'fas',
    //   imageDark: '',
    //   imageLight: '',
    //   label: 'Dev Docs',
    //   labelDisable: true,
    //   itemDisable: false,
    //   name: 'Dev Docs',
    //   pageTitle: 'Dev Docs',
    //   to: routes.RESOURCES_DEV_DOCS
    // },
    // {
    //   active: true,
    //   allowedRoles: ['super-admin', 'admin', 'user'],
    //   description:
    //     'Read the latest news and updates that are relevant to you and your organization',
    //   development: true,
    //   icon: 'newspaper',
    //   iconCollection: 'fas',
    //   imageDark: '',
    //   imageLight: '',
    //   label: 'News & Updates',
    //   labelDisable: true,
    //   itemDisable: false,
    //   name: 'News & Updates',
    //   pageTitle: 'News & Updates',
    //   to: routes.RESOURCES_NEWS_UPDATES
    // },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Report an issue or bug to the development team for review and resolution',
      development: true,
      icon: 'triangle-exclamation',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Report An Issue',
      labelDisable: true,
      itemDisable: false,
      name: 'Report An Issue',
      pageTitle: 'Report An Issue',
      to: routes.RESOURCES_REPORT_ISSUE
    }
  ]
};

/**
 * The resources routes for reading news and updates.
 *
 * @type {Object}
 *
 * @author Brandon Cummings <brandon.cummings@leargassecurity.com>
 * @version 0.1.0-beta.5
 * @since 0.1.0-beta.1
 */
export const toolsRoutes = {
  active: true,
  allowedRoles: ['super-admin', 'admin', 'user'],
  description: 'Access tools that help you manage and monitor your environment',
  development: false,
  icon: 'toolbox',
  iconCollection: 'fas',
  iconGrow: 2,
  imageDark: '',
  imageLight: '',
  label: 'Tools',
  labelDisable: false,
  itemDisable: false,
  name: 'Tools',
  pageTitle: 'Tools',
  to: routes.TOOLS,
  children: [
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description:
        'Lookup an IP address, domain, or URL to see if it is known to be malicious',
      development: false,
      icon: 'crosshairs',
      iconGrow: 3,
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Aurora',
      labelDisable: true,
      itemDisable: false,
      name: 'Aurora',
      pageTitle: 'Aurora Threat Intelligence',
      to: routes.TOOLS_IP_LOOKUP
    }
  ]
};

export const databaseClusterRoutes = {
  active: true,
  allowedRoles: ['super-admin', 'admin'],
  description:
    'View and manage the MongoDB database, including collections, health, and users',
  development: true,
  icon: 'database',
  iconCollection: 'fas',
  imageDark: '',
  imageLight: '',
  label: 'DB Cluster',
  labelDisable: true,
  itemDisable: false,
  name: 'DB Cluster',
  pageTitle: 'DB Cluster',
  to: routes.SYSTEM_TOOLS_DB,
  children: [
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review audit logs and other audit log-related information for the MongoDB database',
      development: true,
      icon: '',
      iconCollection: '',
      imageDark: '',
      imageLight: '',
      label: 'Audit Logs',
      labelDisable: true,
      itemDisable: false,
      name: 'Audit Logs',
      pageTitle: 'Audit Logs',
      to: routes.SYSTEM_TOOLS_DB_AUDIT_LOGS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review collections and other collection-related information for the MongoDB database',
      development: true,
      icon: '',
      iconCollection: '',
      imageDark: '',
      imageLight: '',
      label: 'Collections',
      labelDisable: true,
      itemDisable: false,
      name: 'Collections',
      pageTitle: 'Collections',
      to: routes.SYSTEM_TOOLS_DB_COLLECTIONS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review database health and get an overview of the MongoDB database resource usage at a glance',
      development: true,
      icon: '',
      iconCollection: '',
      imageDark: '',
      imageLight: '',
      label: 'Health',
      labelDisable: true,
      itemDisable: false,
      name: 'Health',
      pageTitle: 'Health',
      to: routes.SYSTEM_TOOLS_DB_HEALTH
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review database nodes, their health, resources and other node-related information',
      development: true,
      icon: '',
      iconCollection: '',
      imageDark: '',
      imageLight: '',
      label: 'Nodes',
      labelDisable: true,
      itemDisable: false,
      name: 'Nodes',
      pageTitle: 'Nodes',
      to: routes.SYSTEM_TOOLS_DB_NODES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'View and manage database users and user settings',
      development: true,
      icon: '',
      iconCollection: '',
      imageDark: '',
      imageLight: '',
      label: 'Users',
      labelDisable: true,
      itemDisable: false,
      name: 'Users',
      pageTitle: 'Users',
      to: routes.SYSTEM_TOOLS_DB_USERS
    }
  ]
};

export const searchClusterRoutes = {
  active: true,
  allowedRoles: ['super-admin', 'admin'],
  description: 'View and manage the search cluster health, nodes, and indices',
  development: false,
  icon: 'circle-nodes',
  iconCollection: 'fas',
  imageDark: '',
  imageLight: '',
  label: 'Search Cluster',
  labelDisable: true,
  itemDisable: false,
  name: 'Search Cluster',
  pageTitle: 'Search Cluster',
  to: routes.SYSTEM_TOOLS_ES,
  children: [
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review audit logs and other audit log-related information for the Elasticsearch cluster',
      development: true,
      icon: '',
      iconCollection: '',
      imageDark: '',
      imageLight: '',
      label: 'Audit Logs',
      labelDisable: true,
      itemDisable: false,
      name: 'Audit Logs',
      pageTitle: 'Audit Logs',
      to: routes.SYSTEM_TOOLS_ES_AUDIT_LOGS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review cluster health and get an overview of the search cluster resource usage at a glance',
      development: false,
      icon: 'heart-pulse',
      iconCollection: 'fas',
      hideIconInSidebar: true,
      imageDark: '',
      imageLight: '',
      label: 'Health Overview',
      labelDisable: true,
      itemDisable: false,
      name: 'Health Overview',
      pageTitle: 'Health Overview',
      to: routes.SYSTEM_TOOLS_ES_HEALTH
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review cluster indices and other index-related information for the Elasticsearch cluster',
      development: true,
      icon: '',
      iconCollection: '',
      imageDark: '',
      imageLight: '',
      label: 'Indices',
      labelDisable: true,
      itemDisable: false,
      name: 'Indices',
      pageTitle: 'Indices',
      to: routes.SYSTEM_TOOLS_ES_INDICES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Review cluster nodes, their health, resources and other node-related information',
      development: false,
      icon: 'server',
      iconCollection: 'fas',
      hideIconInSidebar: true,
      imageDark: '',
      imageLight: '',
      label: 'Nodes',
      labelDisable: true,
      itemDisable: false,
      name: 'Nodes',
      pageTitle: 'Nodes',
      to: routes.SYSTEM_TOOLS_ES_NODES
    }
  ]
};

/**
 * The system routes for managing the application.
 *
 * @type {Object}
 *
 * @author Brandon Cummings <brandon.cummings@leargassecurity.com>
 * @version 0.1.0-beta.5
 * @since 0.1.0-beta.1
 */
export const systemRoutes = {
  active: true,
  allowedRoles: ['super-admin', 'admin'],
  description:
    'View and manage the different entities and resources that make up the application',
  development: false,
  icon: 'clover',
  iconRotation: 45,
  iconGrow: 4,
  iconCollection: 'fas',
  imageDark: '',
  imageLight: '',
  label: 'System',
  labelDisable: false,
  itemDisable: false,
  name: 'System',
  pageTitle: 'System',
  to: routes.SYSTEM,
  children: [
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage advisories and advisory settings',
      development: true,
      icon: 'bullhorn',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Advisories',
      labelDisable: true,
      itemDisable: false,
      name: 'Advisories',
      pageTitle: 'Advisories',
      to: routes.SYSTEM_ADVISORIES
    },
    // {
    //   active: true,
    //   allowedRoles: ['super-admin', 'admin'],
    //   description: 'Manage rules and settings around alerting',
    //   development: true,
    //   icon: 'exclamation-triangle',
    //   iconCollection: 'fas',
    //   imageDark: '',
    //   imageLight: '',
    //   label: 'Alerts',
    //   labelDisable: true,
    //   itemDisable: false,
    //   name: 'Alerts',
    //   pageTitle: 'Alerts',
    //   to: routes.SYSTEM_ALERTS
    // },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'View and manage appliances and appliance settings',
      development: true,
      icon: 'server',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Appliance',
      labelDisable: true,
      itemDisable: false,
      name: 'Appliances',
      pageTitle: 'Appliances',
      to: routes.SYSTEM_PRODUCTS_APPLIANCES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage dashboards and layouts',
      development: true,
      icon: 'dashboard',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Dashboards',
      labelDisable: true,
      itemDisable: false,
      name: 'Dashboards',
      pageTitle: 'Dashboards',
      to: routes.SYSTEM_DASHBOARDS
    },
    databaseClusterRoutes,
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage threat detections and detection rules',
      development: true,
      icon: 'crosshairs',
      iconGrow: 3,
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Detections',
      labelDisable: true,
      itemDisable: false,
      name: 'Detections',
      pageTitle: 'Detections',
      to: routes.SYSTEM_DETECTIONS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage fields and field settings',
      development: false,
      icon: 'table-cells',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Fields',
      labelDisable: true,
      itemDisable: false,
      name: 'Fields',
      pageTitle: 'Fields',
      to: routes.SYSTEM_FIELDS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage indices and index settings',
      development: false,
      icon: 'box-archive',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Indices',
      labelDisable: true,
      itemDisable: false,
      name: 'Indices',
      pageTitle: 'Indices',
      to: routes.SYSTEM_INDICES
    },
    {
      // Industries
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage industries and industry settings',
      development: true,
      icon: 'industry',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Industries',
      labelDisable: true,
      itemDisable: false,
      name: 'Industries',
      pageTitle: 'Industries',
      to: routes.SYSTEM_INDUSTRIES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'View and manage system integrations and their settings and configurations',
      development: true,
      icon: 'right-left',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Integrations',
      labelDisable: true,
      itemDisable: false,
      name: 'Integrations',
      pageTitle: 'Integrations',
      to: routes.SYSTEM_INTEGRATIONS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage application jobs and scheduled tasks',
      development: false,
      icon: 'truck-loading',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Jobs',
      labelDisable: true,
      itemDisable: false,
      name: 'Jobs',
      pageTitle: 'Jobs',
      to: routes.SYSTEM_JOBS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage menus and navigation',
      development: true,
      icon: 'bars',
      iconGrow: 2,
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Menus',
      labelDisable: true,
      itemDisable: false,
      name: 'Menus',
      pageTitle: 'Menus',
      to: routes.SYSTEM_MENUS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage organizations details and settings',
      development: false,
      icon: 'city',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Organizations',
      labelDisable: true,
      itemDisable: false,
      name: 'Organizations',
      pageTitle: 'Organizations',
      to: routes.SYSTEM_ORGS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage permissions for roles, users and teams',
      development: true,
      icon: 'key',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Permissions',
      labelDisable: true,
      itemDisable: false,
      name: 'Permissions',
      pageTitle: 'Permissions',
      to: routes.SYSTEM_PERMISSIONS
    },
    // {
    //   active: true,
    //   allowedRoles: ['super-admin', 'admin'],
    //   description:
    //     'Manage products, including appliances and integrations, and their settings',
    //   development: false,
    //   icon: 'shopping-bag',
    //   iconCollection: 'fas',
    //   imageDark: '',
    //   imageLight: '',
    //   label: 'Products',
    //   labelDisable: true,
    //   itemDisable: false,
    //   name: 'Products',
    //   pageTitle: 'Products',
    //   to: routes.SYSTEM_PRODUCTS,
    //   children: [
    //     {
    //       active: true,
    //       allowedRoles: ['super-admin', 'admin'],
    //       description:
    //         'View and manage integration settings and configurations',
    //       development: true,
    //       icon: '',
    //       iconCollection: '',
    //       imageDark: '',
    //       imageLight: '',
    //       label: 'Integrations',
    //       labelDisable: true,
    //       itemDisable: false,
    //       name: 'Integrations',
    //       pageTitle: 'Integrations',
    //       to: routes.SYSTEM_PRODUCTS_INSTANCES
    //     }
    //   ]
    // },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage application releases and release notes',
      development: false,
      icon: 'leaf',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Releases',
      labelDisable: true,
      itemDisable: false,
      name: 'Releases',
      pageTitle: 'Releases',
      to: routes.SYSTEM_RELEASES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description:
        'Manage the generation of different report types for an organization',
      development: true,
      icon: 'chart-line',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Reports',
      labelDisable: true,
      itemDisable: false,
      name: 'Reports',
      pageTitle: 'Reports',
      to: routes.SYSTEM_REPORTS_SETTINGS,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin'],
          description: 'View all reports for all organizations',
          development: true,
          icon: 'chart-line',
          iconCollection: 'fas',
          hideIconInSidebar: true,
          imageDark: '',
          imageLight: '',
          label: 'Reports',
          labelDisable: true,
          itemDisable: false,
          breadcrumbDisable: true,
          name: 'All Reports',
          pageTitle: 'All Reports',
          to: routes.SYSTEM_REPORTS
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin'],
          description:
            'Create a report for an organization, site, appliance or integration',
          development: true,
          icon: 'file-circle-plus',
          iconCollection: 'fas',
          hideIconInSidebar: true,
          imageDark: '',
          imageLight: '',
          label: 'Create a Report',
          labelDisable: true,
          itemDisable: false,
          name: 'Create a Report',
          pageTitle: 'Create a Report',
          to: routes.SYSTEM_REPORTS_CREATE
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin'],
          description:
            'Manage automatic report generation for an organization, site, appliance or integration',
          development: true,
          icon: 'gears',
          iconCollection: 'fas',
          hideIconInSidebar: true,
          imageDark: '',
          imageLight: '',
          label: 'Automation',
          labelDisable: true,
          itemDisable: false,
          name: 'Automation',
          pageTitle: 'Automation',
          to: routes.SYSTEM_REPORTS_SETTINGS
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin'],
          description:
            'Manage automatic report generation for an organization, site, appliance or integration',
          development: true,
          icon: 'layer-group',
          iconCollection: 'fas',
          hideIconInSidebar: true,
          imageDark: '',
          imageLight: '',
          label: 'Report Types',
          labelDisable: true,
          itemDisable: false,
          name: 'Report Types',
          pageTitle: 'Report Types',
          to: routes.SYSTEM_REPORTS_TYPES
        }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage application resource types and settings',
      development: true,
      icon: 'sourcetree',
      iconCollection: 'fab',
      imageDark: '',
      imageLight: '',
      label: 'Resources',
      labelDisable: true,
      itemDisable: false,
      name: 'Resources',
      pageTitle: 'Resources',
      to: routes.SYSTEM_RESOURCES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage application user roles and role settings',
      development: true,
      icon: 'hard-hat',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Roles',
      labelDisable: true,
      itemDisable: false,
      name: 'Roles',
      pageTitle: 'Roles',
      to: routes.SYSTEM_ROLES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage saved searches and search settings',
      development: true,
      icon: 'magnifying-glass',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Searches',
      labelDisable: true,
      itemDisable: false,
      name: 'Searches',
      pageTitle: 'Searches',
      to: routes.SYSTEM_SEARCHES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage organizations details and settings',
      development: true,
      icon: 'map-marked-alt',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Sites',
      labelDisable: true,
      itemDisable: false,
      name: 'Sites',
      pageTitle: 'Sites',
      to: routes.SYSTEM_SITES
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage routes and route settings',
      development: true,
      icon: 'route',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Routes',
      labelDisable: true,
      itemDisable: false,
      name: 'Routes',
      pageTitle: 'Routes',
      to: routes.SYSTEM_ROUTES
    },
    searchClusterRoutes,
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage settings for data enrichment and display',
      development: true,
      icon: 'gears',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Settings',
      labelDisable: true,
      itemDisable: false,
      name: 'Settings',
      pageTitle: 'Settings',
      to: routes.SYSTEM_SETTINGS,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin'],
          description:
            'Manage general application settings, including email recipients, privacy, and general security settings',
          development: true,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/settingsDark.png',
          imageLight: '/assets/img/illustrations/settingsLight.png',
          label: 'General',
          labelDisable: true,
          itemDisable: false,
          name: 'General',
          pageTitle: 'General',
          to: routes.SYSTEM_SETTINGS_GENERAL
        },
        {
          active: true,
          allowedRoles: ['super-admin', 'admin'],
          description:
            'Manage privacy settings, including privacy mode behavior and privacy policy information',
          development: true,
          icon: '',
          iconCollection: '',
          imageDark: '/assets/img/illustrations/privacyDark.png',
          imageLight: '/assets/img/illustrations/privacyLight.png',
          label: 'Privacy',
          labelDisable: true,
          itemDisable: false,
          name: 'Privacy',
          pageTitle: 'Privacy',
          to: routes.SYSTEM_SETTINGS_PRIVACY
        }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage subscriptions and subscriptions levels',
      development: true,
      icon: 'receipt',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Subscriptions',
      labelDisable: true,
      itemDisable: false,
      name: 'Subscriptions',
      pageTitle: 'Subscriptions',
      to: routes.SYSTEM_SUBS,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin'],
          description: 'View and manage organization subscription levels',
          development: false,
          icon: '',
          iconCollection: '',
          imageDark: '',
          imageLight: '',
          label: 'Levels',
          labelDisable: true,
          itemDisable: false,
          name: 'Levels',
          pageTitle: 'Levels',
          to: routes.SYSTEM_SUBS_LEVELS
        }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage user accounts and user access settings',
      development: false,
      icon: 'users',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Users',
      labelDisable: true,
      itemDisable: false,
      name: 'Users',
      pageTitle: 'Users',
      to: routes.SYSTEM_USERS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'Manage visualizations and visualization settings',
      development: true,
      icon: 'chart-pie',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Visualizations',
      labelDisable: true,
      itemDisable: false,
      name: 'Visualizations',
      pageTitle: 'Visualizations',
      to: routes.SYSTEM_VISUALIZATIONS
    }
  ]
};

/**
 * The account routes for the application.
 *
 * @type {Object}
 *
 * @author Brandon Cummings <brandon.cummings@leargassecurity.com>
 * @version 0.1.0-beta.5
 * @since 0.1.0-beta.1
 */
export const accountRoutes = {
  active: true,
  allowedRoles: ['super-admin', 'admin', 'user'],
  development: false,
  description: 'View and manage your account settings and preferences',
  icon: 'user',
  iconCollection: 'fas',
  imageDark: '',
  imageLight: '',
  label: 'Your Account',
  labelDisable: false,
  itemDisable: true,
  name: 'Account',
  pageTitle: 'Account',
  to: routes.ACCOUNT,
  children: [
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description: 'View and manage your account settings and preferences',
      development: false,
      icon: 'cog',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Settings',
      labelDisable: false,
      itemDisable: true,
      name: 'Settings',
      pageTitle: 'Account Settings',
      to: routes.ACCOUNT_SETTINGS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin'],
      description: 'View and manage your API tokens and access keys',
      development: false,
      icon: 'vault',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'API Tokens',
      labelDisable: false,
      itemDisable: true,
      name: 'API Tokens',
      pageTitle: 'API Tokens',
      to: routes.ACCOUNT_API_TOKENS
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description: 'View your account profile and personal information',
      development: false,
      icon: 'address-card',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Profile',
      labelDisable: false,
      itemDisable: true,
      name: 'Profile',
      pageTitle: 'Account Profile',
      to: routes.ACCOUNT_PROFILE,
      children: [
        {
          active: true,
          allowedRoles: ['super-admin', 'admin', 'user'],
          description: 'Edit your account profile and personal information',
          development: false,
          icon: 'pencil-alt',
          iconCollection: 'fas',
          imageDark: '',
          imageLight: '',
          label: 'Edit Profile',
          labelDisable: false,
          itemDisable: true,
          name: 'Edit Profile',
          pageTitle: 'Edit Profile',
          to: routes.ACCOUNT_PROFILE_EDIT
        }
      ]
    },
    {
      active: true,
      allowedRoles: ['super-admin', 'admin', 'user'],
      description: 'View and manage your authorized devices and sessions',
      development: false,
      icon: 'cog',
      iconCollection: 'fas',
      imageDark: '',
      imageLight: '',
      label: 'Devices',
      labelDisable: false,
      itemDisable: true,
      name: 'Devices',
      pageTitle: 'Authorized Devices',
      to: routes.ACCOUNT_DEVICES
    }
  ]
};

const primaryRoutes = [
  {
    active: true,
    allowedRoles: ['super-admin', 'admin', 'user'],
    development: false,
    description:
      "Get a quick overview of your organization's artifacts, threat intel hits, alerts, and more",
    icon: 'house-user',
    iconCollection: 'fas',
    imageDark: '',
    imageLight: '',
    label: 'Overview',
    labelDisable: false,
    itemDisable: false,
    name: 'Overview',
    pageTitle: 'Overview',
    to: routes.OVERVIEW
  }
];

export const managementRoutes = [
  // {
  //   active: true,
  //   allowedRoles: ['super-admin', 'admin', 'user'],
  //   description: 'Manage posts and post settings',
  //   development: false,
  //   icon: 'newspaper',
  //   iconCollection: 'fas',
  //   imageDark: '',
  //   imageLight: '',
  //   label: 'Posts',
  //   labelDisable: true,
  //   itemDisable: false,
  //   name: 'Posts',
  //   pageTitle: 'Posts',
  //   to: routes.POSTS,
  //   children: [
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'Get the latest news and updates that are relevant to you and your organizations',
  //       development: false,
  //       icon: '',
  //       iconCollection: '',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'All Posts',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'All Posts',
  //       pageTitle: 'All Posts',
  //       to: routes.POSTS_ALL
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'Get the latest advisories and alerts that are relevant to you and your organizations',
  //       development: false,
  //       icon: '',
  //       iconCollection: '',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Advisories',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Advisories',
  //       pageTitle: 'Advisories',
  //       to: routes.POSTS_ADVISORIES
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin'],
  //       description:
  //         'Create and manage posts that can be seen by users of the platform',
  //       development: false,
  //       icon: '',
  //       iconCollection: '',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Manage Posts',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Manage Posts',
  //       pageTitle: 'Manage Posts',
  //       to: routes.POSTS_MANAGE
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin'],
  //       description: 'Manage post categories and category settings',
  //       development: false,
  //       icon: '',
  //       iconCollection: '',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Manage Categories',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Manage Categories',
  //       pageTitle: 'Manage Categories',
  //       to: routes.POSTS_CATEGORIES_MANAGE
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin'],
  //       description: 'Manage post tags and tag settings',
  //       development: false,
  //       icon: '',
  //       iconCollection: '',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Manage Tags',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Manage Tags',
  //       pageTitle: 'Manage Tags',
  //       to: routes.POSTS_TAGS_MANAGE
  //     }
  //   ]
  // },
  {
    active: true,
    allowedRoles: ['super-admin', 'admin', 'user'],
    description:
      'View cybersecurity advisories related to your organization and industries',
    development: true,
    icon: 'bullhorn',
    iconCollection: 'fas',
    imageDark: '',
    imageLight: '',
    label: 'Advisories',
    labelDisable: true,
    itemDisable: false,
    name: 'Advisories',
    pageTitle: 'Advisories',
    to: routes.ADVISORIES
  },
  // {
  //   active: true,
  //   allowedRoles: ['super-admin', 'admin', 'user'],
  //   description:
  //     'Manage your alerts and decide which detections you want to be notified about when they occur',
  //   development: true,
  //   icon: 'bell',
  //   iconCollection: 'fas',
  //   imageDark: '',
  //   imageLight: '',
  //   label: 'Alerts',
  //   labelDisable: true,
  //   itemDisable: false,
  //   name: 'Alerts',
  //   pageTitle: 'Alerts',
  //   to: routes.ALERTS
  // },
  {
    active: true,
    allowedRoles: ['super-admin', 'admin', 'user'],
    description:
      'View and manage your cases, case settings, and case templates',
    development: true,
    icon: 'folder-open',
    iconCollection: 'fas',
    imageDark: '',
    imageLight: '',
    label: 'Cases',
    labelDisable: true,
    itemDisable: false,
    name: 'Cases',
    pageTitle: 'Cases',
    to: routes.CASES
  },
  {
    active: true,
    allowedRoles: ['super-admin', 'admin', 'user'],
    description:
      'View and manage your incidents, incident settings, and incident templates',
    development: true,
    icon: 'fire',
    iconCollection: 'fas',
    imageDark: '',
    imageLight: '',
    label: 'Incidents',
    labelDisable: true,
    itemDisable: false,
    name: 'Incidents',
    pageTitle: 'Incidents',
    to: routes.INCIDENTS
  },
  // {
  //   active: true,
  //   allowedRoles: ['super-admin', 'admin', 'user'],
  //   description:
  //     'View and manage your network inventories, and view recently detected anomolies',
  //   development: true,
  //   icon: 'network-wired',
  //   iconCollection: 'fas',
  //   imageDark: '',
  //   imageLight: '',
  //   label: 'Networks',
  //   labelDisable: true,
  //   itemDisable: false,
  //   name: 'Networks',
  //   pageTitle: 'Networks',
  //   to: routes.NETWORKS,
  //   children: [
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'View and manage your network inventories, and view recently detected anomolies',
  //       development: true,
  //       icon: 'clipboard-list',
  //       iconCollection: 'fas',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Inventories',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Inventories',
  //       pageTitle: 'Inventories',
  //       to: routes.NETWORKS_INVENTORIES
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'View and manage the topology of your network and the devices connected to it',
  //       development: true,
  //       icon: 'diagram-project',
  //       iconCollection: 'fas',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Topologies',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Topologies',
  //       pageTitle: 'Topologies',
  //       to: routes.NETWORKS_TOPOLOGIES
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'View anomalies and suspicious activity detected on your networks and hosts',
  //       development: true,
  //       icon: 'triangle-exclamation',
  //       iconCollection: 'fas',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Anomalies',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Anomalies',
  //       pageTitle: 'Anomalies',
  //       to: routes.NETWORKS_ANOMALIES
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'View alerts and notifications related to your networks and hosts',
  //       development: true,
  //       icon: 'bell',
  //       iconCollection: 'fas',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Alerts',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Alerts',
  //       pageTitle: 'Alerts',
  //       to: routes.NETWORKS_ALERTS
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'View threat intelligence events pertaining to your networks and hosts',
  //       development: true,
  //       icon: 'shield',
  //       iconCollection: 'fas',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Threat Intel Hits',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Threat Intel Hits',
  //       pageTitle: 'Threat Intel Hits',
  //       to: routes.NETWORKS_THREAT_INTEL
  //     },
  //     {
  //       active: true,
  //       allowedRoles: ['super-admin', 'admin', 'user'],
  //       description:
  //         'View and manage your network monitoring settings and configurations',
  //       development: true,
  //       icon: 'gear',
  //       iconCollection: 'fas',
  //       imageDark: '',
  //       imageLight: '',
  //       label: 'Settings',
  //       labelDisable: true,
  //       itemDisable: false,
  //       name: 'Settings',
  //       pageTitle: 'Settings',
  //       to: routes.NETWORKS_SETTINGS
  //     }
  //   ]
  // },
  {
    active: true,
    allowedRoles: ['super-admin', 'admin', 'user'],
    description: 'View and manage your organizations and organization settings',
    development: false,
    icon: 'city',
    iconCollection: 'fas',
    imageDark: '/assets/img/illustrations/organizationsDark.png',
    imageLight: '/assets/img/illustrations/organizationsLight.png',
    label: 'Organizations',
    labelDisable: true,
    itemDisable: false,
    name: 'Organizations',
    pageTitle: 'Organizations',
    to: routes.ORGANIZATIONS,
    children: [
      {
        active: true,
        allowedRoles: ['super-admin', 'admin', 'user'],
        description:
          'Monitor sensor/appliance health and configuration at a glance.',
        development: false,
        icon: 'server',
        iconCollection: 'fas',
        imageDark: '',
        imageLight: '',
        label: 'Appliances',
        labelDisable: true,
        itemDisable: false,
        name: 'Appliances',
        pageTitle: 'Appliances',
        to: routes.APPLIANCES
      },
      {
        active: true,
        allowedRoles: ['super-admin', 'admin', 'user'],
        description:
          'Review ingest coverage and volume broken down by client, sensor, and data type.',
        development: false,
        icon: 'chart-pie',
        iconCollection: 'fas',
        imageDark: '',
        imageLight: '',
        label: 'Ingest',
        labelDisable: true,
        itemDisable: false,
        name: 'Ingest',
        pageTitle: 'Ingest',
        to: routes.ARTIFACTS_INGEST_STATUS
      }
    ]
  },
  {
    active: true,
    allowedRoles: ['super-admin', 'admin', 'user'],
    description: 'View and manage your reports',
    development: false,
    icon: 'chart-line',
    iconCollection: 'fas',
    imageDark: '/assets/img/illustrations/reportsDark.png',
    imageLight: '/assets/img/illustrations/reportsLight.png',
    label: 'Reports',
    labelDisable: true,
    itemDisable: false,
    name: 'Reports',
    pageTitle: 'Reports',
    to: routes.REPORTS
  }
];

/**
 * An array of all routes in the application.
 *
 * @type {Object}
 *
 * @author Brandon Cummings <brandon.cummings@leargassecurity.com>
 * @version 0.1.0-beta.5
 * @since 0.1.0-beta.5
 */
export const allRoutes = [
  {
    active: true,
    allowedRoles: ['super-admin', 'admin', 'user'],
    development: false,
    description: 'This is home',
    icon: 'house-user',
    iconCollection: 'fas',
    imageDark: '',
    imageLight: '',
    label: '',
    labelDisable: true,
    itemDisable: true,
    breadcrumbDisable: false,
    name: '',
    pageTitle: 'Home',
    to: routes.HOME,
    children: [
      ...primaryRoutes,
      artifactRoutes,
      ...managementRoutes,
      resourceRoutes,
      {
        active: true,
        allowedRoles: ['super-admin', 'admin', 'user'],
        description:
          'View and manage your saved searches to simplify your data exploration',
        development: false,
        icon: 'magnifying-glass',
        iconCollection: 'fas',
        iconGrow: 3,
        iconRotation: 0,
        imageDark: '/assets/img/illustrations/savedSearchesDark.png',
        imageLight: '/assets/img/illustrations/savedSearchesLight.png',
        label: 'Searches',
        labelDisable: true,
        itemDisable: false,
        name: 'Searches',
        pageTitle: 'Searches',
        to: routes.SEARCHES
      },
      systemRoutes,
      toolsRoutes,
      // {
      //   active: true,
      //   allowedRoles: ['super-admin', 'admin', 'user'],
      //   description:
      //     'View and manage your tickets and get an overview of your ticket statuses',
      //   development: true,
      //   icon: 'receipt',
      //   iconCollection: 'fas',
      //   iconGrow: 3,
      //   iconRotation: 0,
      //   imageDark: '',
      //   imageLight: '',
      //   label: 'Tickets',
      //   labelDisable: true,
      //   itemDisable: false,
      //   name: 'Tickets',
      //   pageTitle: 'Tickets',
      //   to: routes.TICKETS
      // },
      accountRoutes
    ]
  }
];

export default allRoutes;
